import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { BottomNav } from "@/components/BottomNav";
import Feed from "@/pages/Feed";
import Explore from "@/pages/Explore";
import TechProfile from "@/pages/TechProfile";
import Community from "@/pages/Community";
import ThreadDetail from "@/pages/ThreadDetail";
import Dashboard from "@/pages/Dashboard";
import Join from "@/pages/Join";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="pb-16 md:pb-0">
        <Header />
        <main className="min-h-[70vh]">
          <Routes>
            <Route path="/" element={<Feed />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/tech/:username" element={<TechProfile />} />
            <Route path="/community" element={<Community />} />
            <Route path="/community/:id" element={<ThreadDetail />} />
            <Route path="/join" element={<Join />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        </div>
        <BottomNav />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
